import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "phone", "dialCode"]
  static values = {
    countries: Array
  }

  connect() {
    this.sync()
  }

  countryChanged() {
    this.sync()
  }

  sync() {
    const country = this.selectedCountry
    if (!country) return

    if (this.hasDialCodeTarget) {
      this.dialCodeTarget.textContent = country.dial_code
    }
    this.phoneTarget.placeholder = this.placeholderFor(country)
    this.phoneTarget.value = this.localPhoneValue(this.phoneTarget.value, country)
  }

  localPhoneValue(value, country) {
    return value
      .trim()
      .replace(new RegExp(`^\\${country.dial_code}\\s*`), "")
      .replace(/^\+/, "")
      .trim()
  }

  placeholderFor(country) {
    if (country.code === "UA") return "50 123 45 67"

    return "phone number"
  }

  get selectedCountry() {
    const code = this.countryTarget.value
    return this.countriesValue.find(c => c.code === code)
  }
}
